import { defineMessages } from 'react-intl';

const messages = defineMessages({
  formTitle: {
    id: 'Formulário Dados Externos',
    defaultMessage: 'Formulário Dados Externos',
  },
  title: {
    id: 'Título',
    defaultMessage: 'Título',
  },
  no_result: {
    id: 'Sem resultados',
    defaultMessage: 'Sem resultados',
  },
  msgNoResults: {
    id: 'Mensagem padrão',
    defaultMessage: 'Mensagem padrão',
  },
  msgNoResultsEx: {
    id: 'Mensagem detalhada',
    defaultMessage: 'Mensagem detalhada',
  },
});

export const localFormSchema = (props) => {
  return {
    title: props.intl.formatMessage(messages.formTitle),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title'],
      },
      {
        id: 'no_result',
        title: props.intl.formatMessage(messages.no_result),
        fields: ['no_results', 'no_results_ex'],
      },
    ],
    properties: {
      title: {
        title: props.intl.formatMessage(messages.title),
      },
      no_results: {
        title: props.intl.formatMessage(messages.msgNoResults),
        default: 'Nenhum resultado encontrado',
      },
      no_results_ex: {
        title: props.intl.formatMessage(messages.msgNoResultsEx),
        default: '',
      },
    },
    required: ['title'],
  };
};
